export const BRANDING = {
  app_name: "Mira",
  tagline: "The Growth Advisor Built for Martial Arts School & Gym Owners",
  short: "Analytics-grade coaching for school & studio owners.",
};

export const OFFER_DOMAINS = ["studentmagnet.com", "gymmembermagnet.com", "thefollowupninja.com", "getkaratestudents.com"];

export function offerKeyFromUrl(url = "") {
  if (url.includes("getkaratestudents")) return "growth_cta";
  if (url.includes("gymmembermagnet")) return "member_magnet";
  if (url.includes("thefollowupninja")) return "tfun";
  return "student_magnet";
}
